import { logMessage } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';

const mmFetchWithResponse = async (url, options) => {
    const respObj = {};
    respObj.status = false;
    respObj.msg = '';
    respObj.data = {};
    respObj.statusCode = null;

    try {
        const response = await mmFetch(url, options);
        respObj.statusCode = response.status;

        if (response.status === 403) {
            respObj.msg = 'Forbidden';

            // localStorage.removeItem("user");
            // window.location.href = "/login";
        } else if (response.status === 500) {
            const decodedResp = await response.json();
            respObj.msg = decodedResp.msg ? decodedResp.msg : 'Server error. Contact engineering';
        } else if (response.status === 400 || response.status === 404) {
            const decodedResp = await response.json();
            respObj.msg = decodedResp.msg;
            respObj.data = decodedResp.data;
        } else if (response.status === 200 || response.status === 202) {
            respObj.status = true;
            const decodedResp = await response.json();
            respObj.msg = decodedResp.msg;
            respObj.data = decodedResp.data;
        } else {
            logMessage(`Unrecognized status from MM API ${response.status}`);
        }
    } catch (e) {
        // Re-throw AbortError so React Query can handle it properly
        // (cancelled requests shouldn't be treated as errors)
        if (e.name === 'AbortError') {
            throw e;
        }
        respObj.msg = `Error. Contact engineering. ${e.toString()}`;
    }

    return respObj;
};

export { mmFetchWithResponse };
